import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { SharedModule } from 'src/app/private/shared/shared.module';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';
import { UsersService } from '../../../services/users.service';

@Component({
  selector: 'app-create-department',
  standalone: true,
  imports: [SharedModule],
  templateUrl: './create-department.component.html',
  styleUrl: './create-department.component.scss'
})
export class CreateDepartmentComponent {
  @Input() type: string = 'Create';
  @Input() departmentData: any;
  @Output() closeDialog = new EventEmitter();
  @Output() reload = new EventEmitter();

  isSubmitted = false;
  btnLoading = false;

  departmentForm: FormGroup;
  statusOptions = ["Active", "Inactive"];

  @Input() allUsers: any[] = [];
  userOptions: any[] = [];

  constructor(
    private fb: FormBuilder,
    private messageService: MessageService,
    private api: UsersService,
    private localStorage: LocalStorageService
  ) {
    this.departmentForm = this.fb.group({
      name: ['', [Validators.required]],
      code: ['', [Validators.required]],
      description: [''],
      head_of_department: [null],
      contact_number: ['', [Validators.pattern('^[0-9]{10}$')]],
      email: ['', [Validators.required, Validators.email]],
      status: ['Active', [Validators.required]],
      is_public: [false]
    });
  }

  ngOnInit() {
    this.userOptions = this.allUsers.map(user => ({
      label: `${user.fname} ${user.lname}`,
      value: user.user_id
    }));

    if (this.type === 'Update' && this.departmentData) {
      this.departmentForm.patchValue({
        name: this.departmentData.name,
        code: this.departmentData.code,
        description: this.departmentData.description,
        head_of_department: this.departmentData.head_of_department,
        contact_number: this.departmentData.contact_number,
        email: this.departmentData.email,
        status: this.departmentData.status,
        is_public: this.departmentData.is_public
      });
    }
  }

  onSubmit() {
    this.isSubmitted = true;

    if (this.departmentForm.valid) {
      this.btnLoading = true;

      const formData = {
        ...this.departmentForm.value,
        organization_id: this.localStorage.getOrganizationId(),
        campus_id: this.localStorage.getCampusId(),
      };

      if (this.type === 'Create') {
        this.api.createDepartment(formData).subscribe({
          next: () => {
            this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Department created successfully' });
            this.reload.emit();
            this.closeDialog.emit();
          },
          error: (error: any) => {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: error.error.message });
            this.btnLoading = false;
          }
        });
      } else {
        const payload = {
          ...formData,
          dept_id: this.departmentData.dept_id
        };
        this.api.updateDepartment(payload).subscribe({
          next: () => {
            this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Department updated successfully' });
            this.reload.emit();
            this.closeDialog.emit();
          },
          error: (error: any) => {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: error.error.message });
            this.btnLoading = false;
          }
        });
      }
    }
  }

  handleCloseDialog() {
    this.closeDialog.emit();
  }
}
